export const parseIntegerInputOrEmpty = (value) =>
  value === '' ? '' : parseInt(value, 10);

export const parseFloatInputOrEmpty = (value) =>
  value === '' ? '' : parseFloat(value);
